import React,{useState, useEffect}from "react";
import Card from "react-bootstrap/Card";
import axios from "axios";
import ThumbFetch from "../ThumbFetch";
import PlayerFetch from "../PlayerFetch";
import Jumbotron from "react-bootstrap/Jumbotron";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { FaHotjar} from "react-icons/fa";
import Spinner from "react-bootstrap/Spinner";

function Home() {

    const [data, setData] = useState({results:[]});
    const [page, setPage] = useState(1);
    const [url, setUrl] = useState('https://freesound.org/apiv2/search/text/?page_size=5&page=' + page + '&filter=created_desc&token='
        + global.KEY);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            try {
                const result = await axios(url);
                setData(result.data);
            } catch (error) {
                setIsError(true);
            }
            setIsLoading(false);
        };
        fetchData();
    }, [page, url]);


    return (
        <div className="Home">
            {isError && <div>Something went wrong ...</div>}

            {isLoading ? (
                <div><Spinner animation="border" /> Loading ...</div>
            ) : (
                <div className="Home">
                    <Jumbotron>
                        <h1>Welcome to Sound Explorer!</h1>
                        <p>
                            This is a web app based on <a href="https://reactjs.org/" target="_blank" rel="noopener noreferrer">React </a> for a school final project.
                        </p>
                        <p>Search, listen and download for <strong><em>FREE</em></strong>, all kinds of sounds for your multimedia projects.</p>
                        <p>
                            <Button variant="light" ><Link to='/about'>About Us</Link></Button>

                        </p>
                    </Jumbotron>
                    <h3 className="text-muted"><span className="align-text-top"><FaHotjar /></span> Latest Sounds</h3>

                    <div className="pt-4 pb-4">
                        {data.results.map(item => (
                            <Card className="mb-4" key={item.id}>
                                <ThumbFetch id={item.id} />
                                <Card.Body>
                                    <Card.Title><Link to={`/sound/${item.id}`}>{item.name}</Link></Card.Title>
                                    <Card.Text>
                                        {item.name}
                                    </Card.Text>
                                    <Card.Text>
                                        <PlayerFetch id={item.id} />
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        ))}
                    </div>
                </div>
            )}

            <div className="container mb-5">
                <div className="row justify-content-center">
                     <Button variant="secondary"
                             onClick={() => {
                                 setPage(prevState => page + 1)
                             setUrl( prevState => 'http://freesound.org/apiv2/search/text/?&query=&filter=created_desc&page=' +
                                 page + '&page_size=7&token=' + global.KEY)
                             }}>
                         Load more</Button>
                </div>
            </div>
        </div>
    );

}


export default Home;